import { faqItems } from '@/mocks/homeData';

export default function SectionFaq() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">常见问题</span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">常见问题</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">关于高清影视在线观看的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
              <div className="p-5 md:p-6">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-3 flex items-start gap-3">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {item.question}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed pl-8">{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}